import React from 'react';
import { Div } from 'Common/components/Atoms/Div';
import { Flex } from 'Common/components/Atoms/Flex';
import { Text } from 'Common/components/Atoms/Text';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { useTheme } from '@mui/material';
import h1WhiteLogo from 'resources/hackerone_logo_white.png';
import prLogo from 'resources/pullrequest-logo-white.svg';
import {
  faBug,
  faRocketLaunch,
  faBusinessTime,
} from '@fortawesome/pro-solid-svg-icons';
import { Link } from 'Common/components/Atoms/Link';
import { darken } from 'polished';

const LeftPane = () => {
  const theme = useTheme();
  const textColor = darken(0.12, theme.palette.common.white);
  return (
    <Div
      display="flex"
      flexDirection="column"
      width="40%"
      background={`linear-gradient(0.1turn, ${theme.palette.h1.primary.pink}, ${theme.palette.primary.main})`}
      p={6}
      boxSizing="border-box"
    >
      <Flex flexDirection="column">
        <Div
          width={140}
          height={32}
          background={`url(${h1WhiteLogo}) 0% 0% / contain no-repeat`}
        />
        <Flex center mt={1}>
          <Text color={textColor}>Powered by</Text>
          <Div
            width={100}
            height={24}
            background={`url(${prLogo}) 0% 0% / contain no-repeat`}
            ml={1}
          />
        </Flex>
      </Flex>
      <Text
        variant="h2"
        color={textColor}
        fontSize="2.75rem"
        mt={4}
        mb={2}
        pr={4}
      >
        HackerOne Code Review For Security Fixes
      </Text>
      <Flex flexDirection="column">
        <Flex alignItems="center" my={5}>
          <FontIcon size="2x" icon={faBug} color={textColor} />
          <Text variant="h3" color={textColor} ml={4}>
            18% of security fixes are incomplete
          </Text>
        </Flex>
        <Flex alignItems="center" my={5}>
          <FontIcon size="2x" icon={faBusinessTime} color={textColor} />
          <Text variant="h3" color={textColor} ml={4}>
            Don't waste time repeating releases while leaving your app
            vulnerable.
          </Text>
        </Flex>
        <Flex alignItems="center" my={5}>
          <FontIcon size="2x" icon={faRocketLaunch} color={textColor} />
          <Text variant="h3" color={textColor} ml={4}>
            Level up with collaborative reviews from{' '}
            <Link href="https://www.pullrequest.com/reviewers">
              top security engineers
            </Link>{' '}
            to fix vulnerabilities fast, the first time.
          </Text>
        </Flex>
      </Flex>
    </Div>
  );
};

export default LeftPane;
